var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"bordered":"","overlap":"","icon":"fas fa-ban","value":_vm.question.invalidated,"color":"bg-gray-400 text-black"}},[_c('div',{staticClass:"feedback-item font-weight-bolder pointer-on-hover w-100",class:{
      'success' : _vm.successResult,
      'error' : _vm.errorResult,
      'challenge' : !_vm.showResult && _vm.question.user_answer,
      'is-active' : _vm.isActive
    },on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"text-black"},[_vm._v("\n      "+_vm._s(_vm.question.key + 1)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"bg-dark-modal feedback-item__answer text-uppercase pt-1"},[_vm._v("\n      "+_vm._s(_vm.question.user_answer)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }